// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"173411d9","176":"89cd603b","641":"54db12f6","865":"dd6b25ee","989":"93b7c105"}[chunkId] + ".chunk.js";
};